<template>
    <div class="w-full flex flex-col items-center">
        <img
            src="@/assets/img/clinical-manifestations-desktop.svg"
            alt="Primary Clinical Manifestations in PH1"
            class="hidden md:block"
        />
        <img
            src="@/assets/img/clinical-manifestations-mobile.svg"
            alt="Primary Clinical Manifestations in PH1"
            class="md:hidden"
        />

        <h4 class="text-xl font-semibold mt-3">
            These are not all the signs and symptoms of PH1, and not all patients exhibit signs and symptoms at the same
            time
        </h4>
    </div>
</template>
